App.namespace.wrap('es6.shared.regex_validator', function (options) {
  const regexEmail = /^(?!.*\.\.)[a-zA-Z0-9][a-zA-Z0-9._%+-]*[a-zA-Z0-9]@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const isNotEmail = /^((?!(@)).)*$/gi;
  const regexUrl = /^((https?:\/\/)|(www\.))+([\w\.-]+)\..*$/gi;
  const regexNumeric = /^[0-9]+$/gi;
  const phoneNumber = /^\+?\s?[0-9 ()]{8,18}$/gi;

  return {
    isValidEmail: text => {
      let result = text.match(regexEmail);
      return (result !== null) && (result[0] === text);
    },
    isNotEmail: text => (text.match(isNotEmail) !== null),
    isValidUrl: text => (text.match(regexUrl) !== null),
    isNumeric: text => (text.match(regexNumeric) !== null),
    isValidPhone: text => (text.match(phoneNumber) !== null)
  };
});
